import React from 'react'

function LeftArrow() {
  return (
    <span className='leftArrow videoCarouselArrow'><i class="fa fa-arrow-left" aria-hidden="true"></i>
    </span>
  )
}

export default LeftArrow